<template>
  <div id="indexComponent" class="leagues-page">
    <Header
      @onChangLogin="onChangLogin"
      :isLogin="loginShow"
      :setShow="['timeZone']"
      :tsz="svrTimestamp"
      @onChangeSetting="onChangeSetting"
    />
    <NavBar :tab="2" @onChangLogin="onChangLogin" :isLogin="loginShow" />
    <div class="page-content flex flex-pack-justify">
      <div class="page-left">
        <CountryLeagues
          :country="countryObject"
          :league="leagueObject"
          @leagueChange="onLeagueChange"
        />
        <AllLeagues :list="leagueList" @leagueChange="onLeagueChange" />
      </div>
      <div class="page-center">
        <LeagueInfo
          :leagueInfo="leagueInfo"
          :leagueList="leagueList"
          @leagueChange="onLeagueChange"
          @onSeasonChange="onseasonChange"
          @onChangLogin="onChangLogin"
        />
        <!-- tabs -->
        <ul class="tabs flex">
          <li
            v-for="item in tabs"
            :key="item.value"
            @click="changeTabs(item.value)"
            :class="tab == item.value ? 'active' : ''"
          >
            {{ item.label }}
          </li>
        </ul>
        <van-swipe
          class="swiper"
          @change="onSwiperChange"
          :show-indicators="false"
          :loop="true"
          ref="swiperTabs"
        >
          <van-swipe-item>
            <!-- 积分 -->
            <PointsTable
              v-show="tab == '1'"
              :params="{
                leagueId: leagueInfo.league.id,
                season: leagueInfo.currentSeason || '',
              }"
              :setting="setting"
            />
          </van-swipe-item>
          <van-swipe-item>
            <!-- 赛程 -->
            <FixturesTable
              v-show="tab == '2'"
              :params="{
                leagueId: leagueInfo.league.id,
                season: leagueInfo.currentSeason || '',
              }"
              :setting="setting"
              @onChangLogin="onChangLogin"
            />
          </van-swipe-item>
          <!-- <van-swipe-item>
            <TeamsTable 
              v-show="tab == '3'"
              :params="{
                leagueId: leagueInfo.league.id,
                season: leagueInfo.currentSeason || '',
              }"
            />
          </van-swipe-item>
          <van-swipe-item>
            <PlayerTable 
              v-show="tab == '4'"
              :params="{
                leagueId: leagueInfo.league.id,
                season: leagueInfo.currentSeason || '',
              }"
            />
          </van-swipe-item> -->
        </van-swipe>
      </div>
      <div class="page-right">
        <template v-if="ListAd.length > 0">
          <template v-for="(item, index) in ListAd">
            <div class="ad-box" :class="item.flag ? '' : 'ad-no-icon'" v-if="item.siteId == 301" :key="index">
              <router-link
                :to="'/gdt?gdtUrl=' + item.url"
                target="_blank"
                @click.native="adHit(item.id)"
                ><img :src="item.img"
              /></router-link>
            </div>
          </template>
          <template v-for="(item, index) in ListAd">
            <div class="ad-box ad-sticky" :class="item.flag ? '' : 'ad-no-icon'" v-if="item.siteId == 302" :key="index">
              <router-link
                :to="'/gdt?gdtUrl=' + item.url"
                target="_blank"
                @click.native="adHit(item.id)"
                ><img :src="item.img"
              /></router-link>
            </div>
          </template>
        </template>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import { mapState } from "vuex";
import { getLeagueList, getLeagueInfo, getListAd, getAdHits, getLeagueInfoIsFollow, getLeagueDefaultHot, getSEO } from "@/api/api";
import Header from "@/components/header.vue";
import NavBar from "@/components/navbar.vue";
import Footer from "@/components/footer.vue";
import CountryLeagues from "./components/countryLeagues";
import LeagueInfo from "./components/leagueInfo";
import AllLeagues from "./components/allLeagues";
import PointsTable from "./components/pointsTable";
import FixturesTable from "./components/fixturesTable";
import TeamsTable from "./components/teamsTable";
import PlayerTable from "./components/playerTable";
export default {
  name: "leagues",
  components: {
    Header,
    NavBar,
    Footer,
    CountryLeagues,
    LeagueInfo,
    AllLeagues,
    PointsTable,
    FixturesTable,
    TeamsTable,
    PlayerTable,
  },

  // asyncData({ store, route }) {
  //   return store.dispatch("leagues/fetchSEO", {
  //     type: 6,
  //   });

  //   // return Promise.all([
  //   //   this.getMvUrl(store, route),
  //   //   this.getMvLikedCount(store, route),
  //   //   this.getMvDetail(store, route).then(async () => {
  //   //     await this.getArtistDetail(store, route);
  //   //     await this.getArtistMvList(store, route);
  //   //     await store.dispatch("HistoryMv/addHistoryMv", store.state.WatchMv.mv);
  //   //   }),
  //   //   this.getCommentMvList(store, route),
  //   // ]).then();
  // },

  data() {
    return {
      setting: {},
      svrTimestamp: 0, //服务器时间
      ListAd: [],
      loginShow: false,
      id: null,
      countryObject: {},
      leagueObject: {
        id: null,
        shortName: "",
        fullName: "",
      },
      leagueList: [],
      leagueInfo: {
        country: {},
        league: {},
        seasonStart: null,
        seasonEnd: null,
        seasonList: [],
        currentSeason: "",
      },
      tab: this.$route.params?.tab * 1 || "1",
      tabs: [
        { label: this.langConfig.leagues[this.langConfig.curLang]['POINTS'], value: "1" },
        { label: this.langConfig.leagues[this.langConfig.curLang]['FIXTURES'], value: "2" },
        // { label: this.langConfig.leagues[this.langConfig.curLang]['TEAMS'], value: "3" },
        // { label: this.langConfig.leagues[this.langConfig.curLang]['PLAYERS'], value: "4" },
      ],
    };
  },
  mounted() {
    this.loadAdList();
    this.loadLeagueList();
    this.$refs.swiperTabs.swipeTo(
      this.tabs.findIndex((item) => item.value == this.tab)
    );
  },
  computed: {
    ...mapState("leagues", ["SEO"]),
  },
  methods: {
    onChangeSetting(res) {
      this.setting = res;
    },
    async loadAdList() {
      const response = await getListAd({
        //广告
        pageId: 3,
      });
      if (response.state == 200) {
        const _data = this.common.jsonParse(response.data || null);
        // console.log("广告", _data.webAds);
        this.ListAd = _data.webAds || [];
      }
    },
    async loadLeagueList() {
      let leagueId = this.$route.params.id * 1 || "";

      await getLeagueDefaultHot({
        userToken: '',
      }).then((res) => {
        let data=JSON.parse(JSON.stringify(res.data));
        if(leagueId == ''){
          leagueId = data.id;
        }
      }).catch((res) => {
        console.error(res)
      })

      const response = await getLeagueList({
        leagueId,
        userToken: "",
      });
      if (response.state === 200) {
        const _data = response.data;
        const group = _data["group"] || [];
        let _list = [];
        group.forEach((continent) => {
          continent.country.forEach((country) => {
            if (country.id) _list.push(country);
          });
        });
        this.leagueList = _list;
        //console.log("leagueList", JSON.parse(JSON.stringify(_data)));
        const defaultHotLeague = _data.defaultHotLeague || { id: null };
        this.leagueObject = defaultHotLeague;
        // console.log(
        //   "leagueObject",
        //   JSON.parse(JSON.stringify(this.leagueObject))
        // );
        _list.forEach((country) => {
          country.league.forEach((item) => {
            if (item.id == defaultHotLeague.id) {
              this.leagueInfo.country = country;
              this.countryObject = country;
            }
          });
        });
        this.loadLeagueInfo();
        // console.log(
        //   "countryObject",
        //   JSON.parse(JSON.stringify(this.countryObject))
        // );
      }
    },
    async loadLeagueInfo() {
      let userToken = "";
      let _userInfo = this.common.getCookie("userInfo");
      if (_userInfo != null) {
        _userInfo = JSON.parse(_userInfo) || {};
        if ("token" in _userInfo) {
          userToken = _userInfo["token"];
        }
      }
      const response = await getLeagueInfo({
        leagueId: this.leagueObject.id || this.$route.params.id,
        userToken,
      });
      if(typeof(response.serverTimestamp) != 'undefined'){
        this.svrTimestamp = response.serverTimestamp;
      }
      if (response.state === 200) {
        const _data = response.data;
        this.leagueInfo = {
          isFollow: _data["isFollow"] || false,
          country: this.countryObject,
          league: _data["league"] || {},
          seasonStart: _data["seasonStart"] || null,
          seasonEnd: _data["seasonEnd"] || null,
          seasonList: _data["seasonList"] || [],
        };
        // console.log("leagueInfo", JSON.parse(JSON.stringify(this.leagueInfo)));
      }

      await getLeagueInfoIsFollow({
        leagueId: this.leagueObject.id || this.$route.params.id,
        userToken,
      }).then((res) => {
        let data=JSON.parse(JSON.stringify(res.data));
        this.leagueInfo.isFollow =data.isFollow||false;
      }).catch((res) => {
        console.error(res)
      })
    },
    onLeagueChange(country, league) {
      this.countryObject = country;
      this.leagueObject = league;
      this.loadLeagueInfo();
      this.$router.push(
        `/leagues/${league.id}/${this.$route.params?.tab ?? 0}`
      );
    },
    onseasonChange(value) {
      this.leagueInfo.currentSeason = value;
      this.$forceUpdate();
    },
    changeTabs(type) {
      this.tab = type;
      this.$router.push(`/leagues/${this.$route.params.id}/${type}`);
      this.$refs.swiperTabs.swipeTo(
        this.tabs.findIndex((item) => item.value == type)
      );
    },
    onSwiperChange(index) {
      const type = this.tabs[index]["value"];
      this.tab = type;
      this.$router.push(`/leagues/${this.$route.params.id}/${type}`);
    },
    onChangLogin(_val) {
      console.log(_val);
      if (_val.loginShow || _val) {
        this.loginShow = true;
      } else {
        this.loginShow = false;
      }
    },
    // 广告点击
    adHit(id) {
      let _id = id;
      let _param = {
        id: _id,
      };
      getAdHits(_param);
    },
  },

  created() {
    getSEO({ //SEO
      type: 6
    }).then((res) => {
      let _data = JSON.parse(JSON.stringify(res.data));
      document.title = _data.title;
      document.getElementsByName('keywords')[0].content = _data.keyword;
      document.getElementsByName('description')[0].content = _data.description;
    }).catch((res) => {
      console.error(res)
    })
  },
};
</script>

<style lang="less" scoped>
.page-content{
    max-width:1200px;
    margin:0 auto;
    padding:8px 16px 0;
}
.page-left{
    width:168px;
    padding-right:8px;
}
.page-center{
    flex:1;
    max-width:auto;
    min-width:535px;
}
.page-right{
    width:208px;
    padding-left:8px;
}
.leagues-page {
  .tabs {
    font-size: 14px;
    font-family: @font_family_SF_Pro_Display;
    color: @color_000;
    background: @color_FFF;
    line-height: 40px;
    margin-bottom: 8px;
    li {
      padding: 0 16px;
      margin-right: 8px;
      cursor: pointer;
      font-weight: bold;
    }
    li.active {
      color: @color_FF6915;
      position: relative;
    }
    li.active::after {
      display: block;
      content: "";
      position: absolute;
      width: 40px;
      height: 2px;
      background: @color_FF6915;
      left: 50%;
      margin-left: -20px;
      bottom: 0;
    }
  }
  .swiper {
    cursor: default;
  }
}
.ad-box{
    border-radius: 4px;
    overflow: hidden;
    position: relative;
    &::before{
        content: 'AD';
        padding:2px 6px;
        font-size:12px;
        color:@color_FFF;
        border-radius: 0 0 8px 0;
        background-color: rgba(0,0,0,0.7);
        position:absolute;
        top:0;
        left:0;
    }
    a{
        display: block;
        cursor: pointer;
    }
    img{
        width: 100%;
        height: 100%;
        border-radius: 4px;
    }
}
.ad-no-icon{
    &::before{
        display: none;
    }
}
.ad-sticky{
    position:sticky;
    top: 0;
    z-index: 51;
}
@media screen and (max-width: 1026px) {
    .page-right{
        display:none;
    }
}
@media screen and (max-width: 798px) {
    .page-left{
        display:none;
    }
}
@media screen and (max-width: 767px) {
  .page-content{
      max-width: 100%;
      padding:0;
      min-width: auto;
  }
  .page-center{
      max-width: 100%;
      min-width:auto;
  }
  .swiper {
    width: 100%;
    .pointsTableBox{
      min-height: 80vh;
    }
    .fixturesTableBox{
      min-height: 80vh;
    }
  }
  .leagues-page {
    .container {
      position: sticky;
      top: 0;
      z-index: 1;
    }
    .tabs {
      width: 100%;
      font-size: 0.14rem;
      line-height: 0.4rem;
      margin-bottom: 0.08rem;
      position: sticky;
      top: 1rem;
      z-index: 1;
      li {
        padding: 0 16px;
        margin-right: 8px;
        cursor: pointer;
        font-weight: bold;
      }
      li.active {
        &::after {
          width: 0.4rem;
          height: 0.02rem;
          margin-left: -0.2rem;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// ./src/views/leagues/index.vue